import React from 'react'
import PropTypes from 'prop-types'

// Pill styles per derived refund status, which the API works out from the refunds
// recorded against a purchase. Mirrors LicenseStatusBadge so a refunded license and the
// purchase it came from read the same way.
const STATUS_STYLES = {
  Refunded: 'bg-blue-300 text-info',
  'Partially Refunded': 'bg-status-blue text-status-darkBlue',
}

/**
 *
 * RefundStatusBadge
 *
 * - Marks a purchase in the history table that has had money returned on it
 * - Renders nothing for a purchase nothing has come back from, rather than an "Active"
 *   pill on every row — the table is mostly unrefunded purchases, and a badge on all of
 *   them carries no information
 */
const RefundStatusBadge = ({ status }) => {
  if (!status || status === 'None') return null

  return (
    <div
      className={`rounded-full px-2.5 py-0.5 ${
        STATUS_STYLES[status] || 'bg-gray-200 text-gray-600'
      }`}
    >
      <span className="whitespace-nowrap text-xs font-bold">{status}</span>
    </div>
  )
}

RefundStatusBadge.defaultProps = {
  status: null,
}

RefundStatusBadge.propTypes = {
  status: PropTypes.string,
}

export default RefundStatusBadge
